import ArticleTextToSpeech from './articleTextToSpeech'

if (document.querySelector('.articleTextToSpeech')) {
	const articleTextToSpeech = new ArticleTextToSpeech()

	articleTextToSpeech.init()
}
